import { ReactNode } from 'react'
import {
  Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Typography, Box,
} from '@mui/material'
import { FancyButton } from '../../comps/FancyButtons'
import { FS_LG } from '../../common/theme'

interface ConfirmModalProps {
  open: boolean
  title: string
  okLabel?: string
  body?: string
  extra?: string
  children?: ReactNode
  // Optional prefix so callers can disambiguate; defaults to "confirmmodal".
  testIdPrefix?: string
  onConfirm: () => void
  onClose: () => void
  id?: string
}

export default function ConfirmModal({
  open, title, okLabel = 'OK', body, extra, children,
  testIdPrefix = 'confirmmodal',
  onConfirm, onClose,
}: ConfirmModalProps) {
  const handleConfirm = () => { onConfirm(); onClose() }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
      PaperProps={{ 'data-testid': `${testIdPrefix}_dlg` } as any}>
      <DialogTitle sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
        <Typography component="span" variant="subtitle1" data-testid={`${testIdPrefix}_title`}
          sx={{ fontWeight: 600, fontSize: '0.95rem' }}>
          {title}
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ px: 2.5, pt: 2, pb: 2 }}>
        {extra && <DialogContentText data-testid={`${testIdPrefix}_extra`}
          dangerouslySetInnerHTML={{ __html: extra }} sx={{ fontSize: FS_LG, mb: 1 }} />}
        {body && <DialogContentText data-testid={`${testIdPrefix}_body`}
          sx={{ fontSize: FS_LG, mb: 2 }}>{body}</DialogContentText>}
        {children}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
          <FancyButton testId={`${testIdPrefix}_cancel_btn`} onClick={onClose}>Cancel</FancyButton>
          <FancyButton solid testId={`${testIdPrefix}_ok_btn`} onClick={handleConfirm}>{okLabel}</FancyButton>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
